export default __webpack_public_path__ + "d381e5872e561562a7e177afcdf5b424.svg";